import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { MIN_WIDTH_FOR_FILTERS_STYLE } from '../../../constants';
import { useLayout } from '../../layout';
import { useJobFilters, usePrepareFilterOptions } from '../utils';
import {
  InlineFiltersView,
  ModalFiltersView,
  SidePanelFiltersView
} from '../views';
import { Search } from './Search';

export function JobFilters() {
  const { searchEnabled } = useSettings();
  const { widgetContainerWidth } = useLayout();
  const { currentFiltersStyle, activeFilters } = useJobFilters();
  const filterOptions = usePrepareFilterOptions();

  const hasActiveFilters = activeFilters.length > 0;

  if (!searchEnabled && !hasActiveFilters) {
    return null;
  }

  if (currentFiltersStyle === 'sidePanel') {
    return <SidePanelFiltersView filterOptions={filterOptions} />;
  }

  const isNarrowWidget = widgetContainerWidth <= MIN_WIDTH_FOR_FILTERS_STYLE;

  return (
    <FiltersSection _reverse={isNarrowWidget && searchEnabled}>
      <Show when={hasActiveFilters}>
        <FiltersWrapper>
          <Show
            when={currentFiltersStyle === 'inline'}
            fallback={<ModalFiltersView filterOptions={filterOptions} />}
          >
            <InlineFiltersView filterOptions={filterOptions} />
          </Show>
        </FiltersWrapper>
      </Show>

      <Show when={searchEnabled}>
        <Search maxWidth={isNarrowWidget ? undefined : 200} />
      </Show>
    </FiltersSection>
  );
}

const FiltersSection = styled.div.attrs({
  className: createReadableClass({
    component: 'filters',
    element: 'section'
  })
})<{ _reverse: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-top: 20px;

  ${({ _reverse }) => _reverse && 'flex-direction: row-reverse;'}
`;

const FiltersWrapper = styled.div.attrs({
  className: createReadableClass({
    component: 'filters',
    element: 'wrapper'
  })
})`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
